<div
  *ngIf="isLoading$ | async"
  class="absolute inset-0 z-50 flex items-center justify-center bg-loader">

  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" class="w-16 h-16">
    <style>
      .loader-wrap {
        transform-origin: 50px 50px;
        animation: loader-bounce 2.4s ease-in-out infinite;
      }
      .loader-check {
        stroke-dasharray: 80;
        animation: loader-draw 2.4s ease-in-out infinite;
      }
      @keyframes loader-draw {
        0%   { stroke-dashoffset: 80; opacity: 1; }
        40%  { stroke-dashoffset: 0;  opacity: 1; }
        72%  { stroke-dashoffset: 0;  opacity: 1; }
        84%  { stroke-dashoffset: 0;  opacity: 0; }
        85%  { stroke-dashoffset: 80; opacity: 0; }
        100% { stroke-dashoffset: 80; opacity: 0; }
      }
      @keyframes loader-bounce {
        0%, 38%, 100% { transform: scale(1); }
        47%           { transform: scale(1.07); }
        54%           { transform: scale(0.97); }
        60%           { transform: scale(1.02); }
        66%           { transform: scale(1); }
      }
    </style>

    <g class="loader-wrap">
      <rect x="8"  y="8"  width="70" height="14"/>
      <rect x="8"  y="8"  width="14" height="84"/>
      <rect x="8"  y="78" width="70" height="14"/>
      <rect x="78" y="22" width="14" height="56"/>

      <polyline class="loader-check"
        points="28,52 48,66 83,26"
        fill="none"
        [attr.stroke]="loaderColor"
        stroke-width="14"
        stroke-linecap="butt"
        stroke-linejoin="miter"/>
    </g>
  </svg>
</div>
